import { Link } from "react-router-dom";
import SearchBar from "@/components/base/SearchBar";
import { getCategories, getAllSites } from "@/lib/navData";

const hotKeywords = ["招聘", "视频", "学习", "购物", "天气", "开源"];

export default function HeroSection() {
  const siteCount = getAllSites().length;
  const categoryCount = getCategories().length;

  return (
    <section className="relative overflow-hidden bg-primary-900">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20minimal%20geometric%20background%20with%20flowing%20deep%20blue%20gradient%20waves%20and%20soft%20light%20streaks%2C%20modern%20clean%20tech%20aesthetic%2C%20smooth%20high%20detail%2C%20no%20text&width=1920&height=760&seq=nav-hero-01&orientation=landscape"
        alt="51网址导航门户背景"
        title="51网址导航 - 权威实用网址快速访问门户"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-primary-900/90 via-primary-900/85 to-primary-800/90" />

      <div className="relative z-10 max-w-page mx-auto px-4 md:px-6 py-14 md:py-24 text-center">
        <span className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-background-50/15 border border-background-50/25 text-primary-100 text-xs md:text-sm mb-6">
          <i className="ri-verified-badge-line text-accent-300" />
          权威收录 · 分类清晰 · 快速直达
        </span>

        <h1 className="font-heading font-extrabold text-background-50 text-3xl md:text-5xl leading-tight">
          51网址导航
        </h1>
        <p className="text-primary-100 text-base md:text-lg mt-3 max-w-2xl mx-auto leading-relaxed">
          权威实用的网址快速访问门户，热门网站入口、分类索引与最新互联网资源一站式直达。
        </p>

        <div className="max-w-2xl mx-auto mt-8">
          <SearchBar size="lg" />
        </div>

        <div className="flex flex-wrap items-center justify-center gap-2 mt-5">
          <span className="text-primary-200 text-sm">热门搜索：</span>
          {hotKeywords.map((kw) => (
            <Link
              key={kw}
              to={`/search?query=${encodeURIComponent(kw)}`}
              className="px-3 py-1.5 rounded-full bg-background-50/10 border border-background-50/20 text-primary-100 text-sm hover:bg-background-50/20 transition-colors cursor-pointer"
            >
              {kw}
            </Link>
          ))}
        </div>

        <div className="flex items-center justify-center gap-8 md:gap-16 mt-10">
          <div className="text-center">
            <p className="font-heading font-extrabold text-background-50 text-2xl md:text-3xl">{siteCount}+</p>
            <p className="text-primary-200 text-xs md:text-sm mt-1">精选网址</p>
          </div>
          <div className="w-px h-10 bg-background-50/20" />
          <div className="text-center">
            <p className="font-heading font-extrabold text-background-50 text-2xl md:text-3xl">{categoryCount}</p>
            <p className="text-primary-200 text-xs md:text-sm mt-1">网址分类</p>
          </div>
          <div className="w-px h-10 bg-background-50/20" />
          <div className="text-center">
            <p className="font-heading font-extrabold text-background-50 text-2xl md:text-3xl">24h</p>
            <p className="text-primary-200 text-xs md:text-sm mt-1">持续更新</p>
          </div>
        </div>
      </div>
    </section>
  );
}